import type { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { LazyTrelloRenderer } from '@trello/editor/renderer';

import styles from './TemplateStoryAbout.less';

export const TemplateStoryAbout: FunctionComponent<{
  desc: string;
}> = ({ desc }) => {
  if (desc.trim() === '') {
    return null;
  }
  return (
    <div className={styles.markdownContainer}>
      <h3 className={styles.header}>
        <FormattedMessage
          id="templates.templates.about-this-template"
          defaultMessage="About this template"
          description="About this template"
        />
      </h3>
      <LazyTrelloRenderer text={desc} contentType="description" />
    </div>
  );
};
